export default __webpack_public_path__ + "static/kinnami-642e9c1502020198bc3e9029e1325779.png";